import lozad from 'lozad';

export default function () {
  const observer = lozad('[data-image-lazy]', { rootMargin: '0px 0px 1500px' });
  observer.observe();
}
